module.exports = __webpack_public_path__ + "img/Litres_saved.a49585a8.png";